import { BaseService } from './base.service.js';
class AuthService extends BaseService {
    injectAccessToken(token) {
        this.accessToken = token;
    }
}
export const authService = new AuthService();
